import Vue from 'vue';
import Vuex from 'vuex';
import http from '../config/http';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loginInfo: {},
    contentType: 0,
    menuName: '',
    notReadCount: 0,
    stationCard: false //shouye模块控制过站信息卡片显隐
  },
  mutations: {
    setLoginInfo(state, v) {
      state.loginInfo = v;
    },
    setContentType(state, v) {
      state.contentType = v;
    },
    setMenuName(state, v) {
      state.menuName = v;
    },
    showStation(state) {
      state.stationCard = true;
    },
    hideStation(state) {
      state.stationCard = false;
    },
    changeUnread(state, v) {
      if (v.code == 1) {
        state.notReadCount = v.data.notReadCount;
        //console.log(v)
      } else {
        //console.log(v)
      }
    }
  },
  actions: {
    getUnread({ commit }) {
      var session = JSON.parse(localStorage['session']);
      let data = {
        sessionId: session.sessionId,
        userId: session.userId,
        modeCode: '2wf5VkjLvzlz0ml9Bgb4uE22IyPrTycI'
      };
      http.post(data).then((res) => {
        commit('changeUnread', res);
      });
    }
  },
  modules: {}
});
